<template>
  <div class="container">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="row">
        <div class="col-10 text-center">
          <h4>Tiempos Libres</h4>
        </div>
        <div class="col-2 text-right">
          <button class="btn btn-primary" v-on:click="Consultar">Consultar</button>
        </div>
        <div class="col-12 mt-3">
          <table id="result_table" class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
            <thead>
              <tr>
                <th class="th-sm">Clave</th>
                <th class="th-sm">Agente</th>
                <th class="th-sm">Fecha Solicitada</th>
                <th class="th-sm">Hora Inicio</th>
                <th class="th-sm">Hora Fin</th>
                <th class="th-sm">Estatus</th>
                <th class="th-sm"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tiempo_libre of tiempos_libres">
                <td>{{ tiempo_libre.idsolicitud }}</td>
                <td>{{ tiempo_libre.nomagente_sistema }}</td>
                <td>{{ tiempo_libre.fecha_evento }}</td>
                <td>{{ tiempo_libre.hora_inicio_evento }}</td>
                <td>{{ tiempo_libre.hora_fin_evento }}</td>
                <td>{{ tiempo_libre.nomestatus }}</td>
                <td v-if="tiempo_libre.status == '3'">
                  <button class="btn btn-success" v-on:click.prevent="Autorizar_Tiempo_Libre(tiempo_libre.idsolicitud)">Autorizar</button>
                </td>
                <td v-else></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th>Clave</th>
                <th>Agente</th>
                <th>Fecha Solicitada</th>
                <th>Hora Inicio</th>
                <th>Hora Fin</th>
                <th>Estatus</th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import GeneralMixin from "@/components/mixins/General";

export default {
  mixins: [GeneralMixin],
  data() {
    return {
      loading: "",
      result: "d-none",
      tiempos_libres: [],
    };
  },
  methods: {
    Autorizar_Tiempo_Libre(idsolicitud) {
      var that = this;
      swal({
        title: "¿Seguro que desea autorizar la solicitud?",
        text: 'Presiona "OK" para autorizar, "Cancel" para cancelar',
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          that.Si_Autorizar_Tiempo_Libre(idsolicitud);
        } else {
        }
      });
    },
    Si_Autorizar_Tiempo_Libre(idsolicitud) {
      var that = this;
      this.Cargando();
      this.$http
        .post(
          "web/tiempo_libre/autorizar/" + idsolicitud,
          {},
          {
            headers: this.get_request_headers({
              accesstoken: localStorage.getItem("tokenmsal"),
            }),
          }
        )
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.resp == "Excelente") {
            swal("Solicitud Autorizada", "La solicitud fue autorizada con exito", "success");
            this.Consultar();
          } else {
            swal(respuestaJson.resp, "Favor de intentar de nuevo", "error");
            this.Listo();
          }
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
          this.Listo();
        });
    },
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    Listo() {
      var that = this;
      this.loading = "d-none";
      this.result = "";
      $(document).ready(function () {
        $("#result_table").DataTable({
          language: {
            sProcessing: "Procesando...",
            sLengthMenu: "Mostrar _MENU_ registros",
            sZeroRecords: "No se encontraron resultados",
            sEmptyTable: "Ningún dato disponible en esta tabla",
            sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
            sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
            sInfoPostFix: "",
            sSearch: "Buscar:",
            sUrl: "",
            sInfoThousands: ",",
            sLoadingRecords: "Cargando...",
            oPaginate: {
              sFirst: "Primero",
              sLast: "Último",
              sNext: "Siguiente",
              sPrevious: "Anterior",
            },
            oAria: {
              sSortAscending: ": Activar para ordenar la columna de manera ascendente",
              sSortDescending: ": Activar para ordenar la columna de manera descendente",
            },
          },
        });
      });
      $("#accordionSidebar")
        .find(".nav-item")
        .each(function (key, element) {
          $(element).removeClass("active");
        });
      $("#Contratos_opcion").addClass("active");
    },
    Consultar() {
      var that = this;
      this.Cargando();
      this.$http
        .get("web/tiempo_libre", {
          headers: this.get_request_headers({
            accesstoken: localStorage.getItem("tokenmsal"),
          }),
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.tiempos_libres = respuestaJson;
          if (this.tiempos_libres.length == 0) {
            swal("No hay solicitudes", "Por el momento no hay solicitudes", "info");
          }
          this.Listo();
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          if (error.status != 401) {
            swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
          }
          this.Listo();
        });
    },
    Ver_Tiempo_Libre(idsolicitud) {
      this.$router.push({
        name: "Tiempo_Libre",
        params: { idsolicitud: idsolicitud },
      });
    },
  },
  computed: {
    menu() {
      return this.$store.getters.getMenu;
    },
  },
  created() {
    this.Consultar();
  },
};
</script>

<style scoped></style>
